module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/awesome-icons/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 1374
// module chunks = 24